// extracted by extract-css-chunks-webpack-plugin
module.exports = {"googleAdvert":"googleAdvert_PkXc0"};